import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ChatMessageEvent } from '../models/communication/baccarat-events.model';

@Component({
    selector: 'app-chat',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chat.component.html',
    styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnChanges {
    @Input()
    chatEnabled = false;

    @Input()
    messages?: ChatMessageEvent[];

    protected pinnedMessage?: ChatMessageEvent;

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (changes['messages']) {
            this.pinnedMessage = this.messages?.find((message) => message.isSupervisor);
        }
    }
}
